export default {
  "--main-background": "#141A27",
  "--background-normal": "#141A27",
  "--main-color": "#3C7BEA",
  "--task-eva-common-card-bg": "#151A26",
  "--color-main-alpha-08": "rgba(60, 123, 234, 0.08)",
  "--topup-member-card-bg": "#101520",
  "--topup-recharge-input": "#101520",
  "--topup-recharge-input-border": "#4A5962",
  "--background-input-2c2c31": "#101520",
  "--antd-modal-header": "#282D37",
  "--antd-drawer-header": "#282D37",
  "--antd-drawer-header-border": "#282D37",
};
